<div class="attachments-container" *ngIf="attachments?.length > 0">
  <div class="divider"></div>
  <div class="attachments">
    <result-attachment
      data-cy="mail-preview-attachment-item"
      *ngFor="let attachment of attachments; index as i"
      [previewAttachment]="true"
      [model]="attachment"
      [dragMetadata]="dragMetadata"
      [dragAndDrop]="false"
      [openContextMenuOnEnterKey]="i === markedIndex"
      [smallWidth]="true"
      [ngClass]="{ focused: i === markedIndex }"
      click-invoker
      (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
    ></result-attachment>
  </div>
</div>
